import React, { useState } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import Registration from './components/Registration';
import FinReg from './components/FinReg';
import Home from './components/Home';
import Login from './components/Login';
import DigiPraatForm from './components/inskrywingsvorms/DigiPraatForm';
import WipScreen from './components/WipScreen';
import SuksesInskryf from './components/SuksesInskryf';
import AllProjects from './components/AllProjects';
import DigiGroeiForm from './components/inskrywingsvorms/DigiGroeiForm';
import DigiKunsForm from './components/inskrywingsvorms/DigiKunsForm';
import DigiSkryfForm from './components/inskrywingsvorms/DigiSkryfForm';
import DigiSpanPraatForm from './components/inskrywingsvorms/DigiSpanPraatForm';
import DigiSpelForm from './components/inskrywingsvorms/DigiSpelForm';
import DigiTaalForm from './components/inskrywingsvorms/DigiTaalForm';
import DigiTienerToneelForm from './components/inskrywingsvorms/DigiTienerToneelForm';
import DataDashboard from './components/DataDashboard';
import ProjectData from './components/ProjectData';
import PassResend from './components/PassResend';
import FailReg from './components/FailReg';
import UploadBlob from './components/UploadBlob';
import InterimUpload from './components/InterimUpload';

const App = () => {
    const [userEmail, setUserEmail] = useState("");
    const [userAuth, setUserAuth] = useState(false);
    const [isDev, setIsDev] = useState(false);
    const [userProfile, setUserProfile] = useState();
    const [project, setProject] = useState();

    
    return (
        <Layout>
            {isDev ? <Route exact path='/' render={(props) => <WipScreen />} /> : <Route exact path='/' render={(props) => <Home {...props} prop1={userEmail} prop2={{ setUserEmail }} />} /> }
            <Route path='/tekenin' render={(props) => <Login {...props} prop1={{ setUserAuth, setUserProfile }} prop2={{userAuth}} />} />
            <Route path='/activate/' component={Login} />
            <Route path='/uploadblob' component={UploadBlob} />
            <Route exact path='/reg' render={(props) => <Registration {...props} prop1={{ userEmail }} prop2={{ setUserEmail }} />} />
            <Route exact path='/stuurmywagwoord' render={(props) => <PassResend {...props} />} />
            <Route exact path='/failreg' render={(props) => <FailReg {...props} />} /> 
            <Route path='/finreg' render={(props) => <FinReg {...props} prop3={{ userEmail }} />} />
            <Route path='/digipraat' render={(props) => <DigiPraatForm isAuth={{ userAuth }} userProf={{ userProfile }} {...props} />} />
            <Route path='/suksesinskryf' render={(props) => <SuksesInskryf {...props} />} />
            <Route path='/digigroei' render={(props) => <DigiGroeiForm isAuth={{ userAuth }} userProf={{ userProfile }} {...props} />} />
            <Route path='/digikuns' render={(props) => <DigiKunsForm isAuth={{ userAuth }} userProf={{ userProfile }} {...props} />} />
            <Route path='/digiskryf' render={(props) => <DigiSkryfForm isAuth={{ userAuth }} userProf={{ userProfile }} {...props} />} />
            <Route path='/digispanpraat' render={(props) => <DigiSpanPraatForm isAuth={{ userAuth }} userProf={{ userProfile }} {...props} />} />
            <Route path='/digispel' render={(props) => <DigiSpelForm isAuth={{ userAuth }} userProf={{ userProfile }} {...props} />} />
            <Route path='/digitaal' render={(props) => <DigiTaalForm isAuth={{ userAuth }} userProf={{ userProfile }} {...props} />} />
            <Route path='/tienertoneel' render={(props) => <DigiTienerToneelForm isAuth={{ userAuth }} userProf={{ userProfile }} {...props} />} />
            <Route path='/alleprojekte' render={(props) => <AllProjects isAuth={{ userAuth }} userProf={{ userProfile }} {...props} />} />
            <Route path='/datadashboard' render={(props) => <DataDashboard isAuth={{ userAuth }} userProf={{ userProfile }} projectType={{ project }} changeProjType={{ setProject }} {...props} />} />
            <Route path='/data/digipraat' render={(props) => <ProjectData projectType={{ project }} changeProjType={{ setProject }} {...props} />} />
            <Route path='/data/digigroei' render={(props) => <ProjectData projectType={{ project }} changeProjType={{ setProject }} {...props} />} />
            <Route path='/data/digispel' render={(props) => <ProjectData projectType={{ project }} changeProjType={{ setProject }} {...props} />} />
            <Route path='/data/digitaal' render={(props) => <ProjectData projectType={{ project }} changeProjType={{ setProject }} {...props} />} />
            <Route path='/data/digispanpraat' render={(props) => <ProjectData projectType={{ project }} changeProjType={{ setProject }} {...props} />} />
            <Route path='/data/digikuns' render={(props) => <ProjectData projectType={{ project }} changeProjType={{ setProject }} {...props} />} />
            <Route path='/data/tienertoneel' render={(props) => <ProjectData projectType={{ project }} changeProjType={{ setProject }} {...props} />} />
            <Route path='/data/digiskryf' render={(props) => <ProjectData projectType={{ project }} changeProjType={{ setProject }} {...props} />} />
            <Route path='/data/digitienertoneel' render={(props) => <ProjectData projectType={{ project }} changeProjType={{ setProject }} {...props} />} />
            <Route path='/intupload' render={(props) => <InterimUpload {...props} />} />
        </Layout>
    );
    
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js